"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SESSION_MANAGER = exports.REQUEST_METHOD = exports.MONTHS = exports.EXP_UUIDV4 = exports.DAYS = exports.ALLOWED_AUTOCOMPLETE_ATTR_VALUES = void 0;
var EXP_UUIDV4 = exports.EXP_UUIDV4 = "[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89aAbB][a-f0-9]{3}-[a-f0-9]{12}";
var ALLOWED_AUTOCOMPLETE_ATTR_VALUES = exports.ALLOWED_AUTOCOMPLETE_ATTR_VALUES = ["off", "on", "name", "email", "username", "new-password", "current-password", "one-time-code", "street-address", "address-line1", "address-line2", "address-line3", "country", "country-name", "postal-code", "bday", "bday-day", "bday-month", "bday-year", "tel", "tel-country-code", "tel-national", "tel-area-code", "tel-local", "tel-extension"];
var MONTHS = exports.MONTHS = [{
  long: "January",
  short: "Jan"
}, {
  long: "February",
  short: "Feb"
}, {
  long: "March",
  short: "Mar"
}, {
  long: "April",
  short: "Apr"
}, {
  long: "May",
  short: "May"
}, {
  long: "June",
  short: "Jun"
}, {
  long: "July",
  short: "Jul"
}, {
  long: "August",
  short: "Aug"
}, {
  long: "September",
  short: "Sep"
}, {
  long: "October",
  short: "Oct"
}, {
  long: "November",
  short: "Nov"
}, {
  long: "December",
  short: "Dec"
}];
var DAYS = exports.DAYS = [{
  long: "Sunday",
  short: "Sun"
}, {
  long: "Monday",
  short: "Mon"
}, {
  long: "Tuesday",
  short: "Tue"
}, {
  long: "Wednesday",
  short: "Wed"
}, {
  long: "Thursday",
  short: "Thu"
}, {
  long: "Friday",
  short: "Fri"
}, {
  long: "Saturday",
  short: "Sat"
}];
var REQUEST_METHOD = exports.REQUEST_METHOD = {
  DELETE: "delete",
  GET: "get",
  OPTIONS: "options",
  PATCH: "patch",
  POST: "post",
  PUT: "put"
};
var SESSION_MANAGER = exports.SESSION_MANAGER = {
  LOGIN: "login",
  LOGOUT: "logout",
  TOKEN_RETURN_KEY: "returnKey",
  TOKEN_RETURN_URL: "returnUrl",
  TYPES: {
    CONSUMER: "consumer",
    INTERNAL: "internal",
    PARTNERS: "partners"
  }
};